<template>
  <div :id="'favTooltipSpan' + uniqueId" class="btn btn-white btn-rounded favorite-button pointer" @click="toggleFavorites()">
    <template v-if="isInFavorites">
      <TyIcon icon="ty-heart-full" color="red" width="1rem" height="1rem"></TyIcon>
      <span v-if="like_text.length > 0">{{ $t(dislike_text) }}</span>
    </template>
    <template v-else>
      <TyIcon icon="ty-heart" color="red" width="1rem" height="1rem"></TyIcon>
      <span v-if="like_text.length > 0">{{ $t(like_text) }}</span>
    </template>

  </div>
</template>

<script setup lang="ts">
import {PropType, ref, computed} from "vue";
import {generateRandomString} from "~/lib/functions";
import {useNuxtApp, useState} from "#app";
import {useStateFunctionFavorites} from "../../../composables/state/favorites";
import {getCurrentUser} from "../../../composables/auth/useAuthUser";
import Accommodation from "../../admin/accommodation.vue";
import {GATracker} from "../../../composables/ga_tracker";

const {GATrackEvent} = GATracker();

const props = defineProps({
    item: Object as PropType<Accommodation>,
    iconClass: String,
    likeText: String,
    dislikeText: String,
    onAction: Function
});
const saving = ref(false);
const {$tyrionApi} = useNuxtApp();
const {favorites, addToFavorite, removeFromFavorite} = useStateFunctionFavorites();
const loggedClient = getCurrentUser();

const isInFavorites = computed(() => {
    return props.item.isInFavorites(favorites.value);
})

const like_text = computed(() => {
    return props.likeText !== undefined ? props.likeText : 'like';
})

const dislike_text = computed(() => {
    return props.dislikeText !== undefined ? props.dislikeText : 'dislike';
})


const uniqueId = computed(() => {
    return generateRandomString(8);
})

const toggleFavorites = () => {
    if (saving.value === false && props.item && loggedClient.value && typeof loggedClient.value.token === 'string' && loggedClient.value.token.length > 5) {
        if (isInFavorites.value) {
            removeFromFavorites();
        } else {
            addToFavorites();
        }
    } else if (!loggedClient.value || !loggedClient.value.token) {
        useState('login-modal').value = true;
    }
}

const addToFavorites = () => {
    saving.value = true;
    $tyrionApi.postTyrionUrl("/api3/client/favorites/add", {
        body: {item: props.item.id},
        userTokenRequired: true
    }).then((res) => {
        if (res.status === "success") {
            addToFavorite({id: props.item.id});
            if (props.onAction) {
                props.onAction();
            }
            GATrackEvent({
                event: 'add_to_favorite',
                action: 'click',
                label: 'add item to favorite',
                value: props.item.link,
                items: [
                    {
                        item_id: props.item.id,
                        item_name: props.item.title,
                    }
                ]
            }, 0)
        }
    }).finally(() => {
        saving.value = false;
    })
}

const removeFromFavorites = () => {
    saving.value = true;
    $tyrionApi.postTyrionUrl("/api3/client/favorites/delete", {
        body: {item: props.item.id},
        userTokenRequired: true
    }).then((res) => {
        if (res.status === "success") {
            removeFromFavorite({id: props.item.id});
            if (props.onAction) {
                props.onAction();
            }

            GATrackEvent({
                event: 'remove_from_favorites',
                action: 'click',
                label: 'remove item from favorite',
                value: props.item.link,
                items: [
                    {
                        item_id: props.item.id,
                        item_name: props.item.title,
                    }
                ]
            }, 0)
        }
    }).finally(() => {
        saving.value = false;
    })
}

</script>
